<div id="TASKPACK" (click)="getAllTaskPack()"></div>
<div class="one" fxLayout="column" [ngClass]="COLOR">
  <!-- <h3 style="margin-top: 5px;margin-bottom: 0px;"><b>Lookups allow you to predefine lists that make it easy to select from a list when entering data throughout SILQ.</b>
  Eg Narrations for time entries.<br>Select the list you want to edit and then add or edit the lookup that you want.</h3><br>
  <div class="border-line"></div><br> -->
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="btn-disp">
    <div fxFlex="30" class="pr-1" class="example" appearance="outline"></div>
    <div>
      <button
        (click)="TaskPackAddEdit('Add Task Pack')"
        mat-flat-button=""
        color="accent"
        class="spend-money-button btn-text mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
      >
        <mat-icon class="fs-21">add</mat-icon>
        Add
      </button>
      <button
        (click)="TaskPackAddEdit('Edit Task Pack')"
        mat-flat-button=""
        color="accent"
        class="spend-money-button btn-text mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
      >
        <!-- (click)="addDuplicateActivities('Duplicate')" -->
        <mat-icon class="fs-21">edit</mat-icon>
        Edit
      </button>

      <button
        (click)="TaskPackAddEdit('Duplicate Task Pack')"
        mat-flat-button=""
        color="accent"
        class="mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 bottom-button spend-money-button"
        style="margin-right: 10px"
      >
        <mat-icon class="fs-21">file_copy</mat-icon>
        Duplicate
      </button>

      <button
        (click)="deleteTaskPack()"
        mat-flat-button=""
        color="accent"
        class="spend-money-button mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14"
      >
        <!-- (click)="addDuplicateActivities('Duplicate')" -->
        <mat-icon class="fs-21">delete</mat-icon>
        Delete
      </button>
    </div>
  </div>
  <br />
  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    fxFlex="1 0 auto"
    class="lookup_main_div_workflow"
  >
    <div class="example-container-data" [ngClass]="class == true ? 'height-458' : 'height-457'">
      @if (isLoadingResults) {
        <div class="example-loading-shade">
          <mat-spinner [style.zoom]="1"></mat-spinner>
        </div>
      }
      <table
        mat-table
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        (matSortChange)="sortData($event)"
        matSortActive="{{ sortactive }}"
        matSortDirection="{{ sortDirection }}"
        matSortDisableClear
        matSort
      >
        <ng-container matColumnDef="Matter Class">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="MATTERCLASS">Matter Class</th>
          <td mat-cell *matCellDef="let element" class="left-align">
            {{ element.MATTERCLASS }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Order">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="TASKPACKORDER">Order</th>
          <td mat-cell *matCellDef="let element" class="left-align">
            {{ element.TASKPACKORDER }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Default">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="DEFAULTPACK">Default</th>
          <td mat-cell *matCellDef="let element" class="left-align">
            {{ element.DEFAULTPACK }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="PACKDESCRIPTION">Description</th>
          <td mat-cell *matCellDef="let element">
            {{ element.PACKDESCRIPTION }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky-header-row"></tr>
        <tr
          [ngClass]="COLOR"
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="editTaskPacks(row); highlightedRows = row.TASKPACKGUID"
          [class.highlighted-row]="highlightedRows === row.TASKPACKGUID"
        ></tr>
      </table>
    </div>
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50, 100]"
      [pageSize]="50"
      showFirstLastButtons
      aria-label="Select page of periodic elements"
    ></mat-paginator>
  </div>
</div>
